import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/chat-assignment`;

export default {
  show() {
    return Client.get(`${resource}`);
  },
  create(payload) {
    return Client.post(`${resource}/create`, payload);
  },
  update(payload) {
    return Client.put(`${resource}`, payload);
  },
};
